import axios from "axios";
import { APIURL } from "../utils/misc";
import {
  SET_BOOKING,
  HOME_BOOKINGS,
  EXPERIENCE_BOOKINGS,
  CALENDAR_EVENTS_LOADED,
  CALENDAR_HOMES_LOADED,
  CALENDAR_LOADING,
} from "./types";
import { toast } from "react-toastify";
import api from "src/utils/api";

export function setBooking(booking) {
  return {
    type: SET_BOOKING,
    booking,
  };
}

export function fetchBookings() {
  return async (dispatch) => {
    try {
      const res = await axios.get(`${APIURL}bookings/viewBookings`);
      dispatch(setBooking(res.data));
    } catch (error) {
      console.error("err", error);
    }
  };
}

export const fetchCalendarEvents =
  (homeId = null, month = null) =>
  async (dispatch) => {
    try {
      dispatch({ type: CALENDAR_LOADING });

      const params = new URLSearchParams();
      if (homeId) params.append("home_id", homeId);
      if (month) params.append("month", month);

      const res = await api.get(`homes/host/calendar/?${params.toString()}`);

      const { events, homes } = res.data;

      // Transform for react-big-calendar
      const calendarEvents = events.map((evt) => ({
        id: evt.id,
        title: evt.title,
        start: new Date(evt.start),
        end: new Date(evt.end),
        homeId: evt.home_id,
        homeTitle: evt.home_title,
        eventType: evt.event_type,
        status: evt.status,
        description: evt.description,
        guestName: evt.guest_name,
        guestCount: evt.guest_count,
      }));

      dispatch({ type: CALENDAR_EVENTS_LOADED, payload: calendarEvents });
      dispatch({ type: CALENDAR_HOMES_LOADED, payload: homes });
    } catch (error) {
      toast.error("Failed to load calendar events.");
    }
  };

// ── Block dates manually ──
export const blockDates = (data) => async (dispatch) => {
  try {
    await api.post(`homes/host/calendar/`, {
      home_id: data.homeId,
      start_date: data.startDate,
      end_date: data.endDate,
      reason: data.reason || "",
    });
    toast.success("Dates blocked successfully.");
    dispatch(fetchCalendarEvents());
  } catch (error) {
    const msg =
      error.response?.data?.error || "Failed to block dates. Try again.";
    toast.error(msg);
  }
};

// ── Unblock dates ──
export const unblockDates = (data) => async (dispatch) => {
  try {
    await api.delete(`homes/host/calendar/unblock/`, {
      data: {
        home_id: data.homeId,
        start_date: data.startDate,
        end_date: data.endDate,
      },
    });
    toast.success("Dates unblocked successfully.");
    dispatch(fetchCalendarEvents());
  } catch (error) {
    toast.error("Failed to unblock dates. Try again.");
  }
};

export const homeBookingsFetchAsync = () => async (dispatch) => {
  try {
    const res = await api.get(`homes/host/bookings`);
    dispatch({
      type: HOME_BOOKINGS,
      payload: res.data.data,
    });
  } catch (error) {
    console.error("err", error);
  }
};

export const experienceBookingsFetchAsync = () => async (dispatch) => {
  try {
    const res = await api.get(`experiences/host/bookings`);
    dispatch({
      type: EXPERIENCE_BOOKINGS,
      payload: res.data.data,
    });
  } catch (error) {
    console.error("err", error);
  }
};
